module.exports = __webpack_public_path__ + "static/media/third_declension_img.6dcbf492.JPG";